import { useCallback, useEffect, useState } from "react";
import {
  getFullPlatformStatus,
  updatePlatformStatus,
  FullPlatformStatus,
  UpdatePlatformStatusDto,
} from "../services/platform-status";
import { useNotification } from "./useNotification";

export const usePlatformStatus = () => {
  const [status, setStatus] = useState<FullPlatformStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const { notify } = useNotification();

  const fetchStatus = useCallback(async () => {
    setLoading(true);
    setLoadError(false);
    try {
      // Admin read: /platform-status/full also returns allowed_school_ids
      const data = await getFullPlatformStatus();
      setStatus(data);
    } catch (error: any) {
      setLoadError(true);
      notify(
        "error",
        "Error al cargar el estado de la plataforma",
        error.response?.data?.message ||
          "No se pudo obtener el estado de mantenimiento"
      );
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateStatus = useCallback(
    async (data: UpdatePlatformStatusDto) => {
      setSaving(true);
      try {
        const updated = await updatePlatformStatus(data);
        setStatus(updated);
        notify(
          "success",
          "Estado actualizado",
          updated.maintenance_mode
            ? "El modo mantenimiento quedó activado"
            : "El modo mantenimiento quedó desactivado"
        );
        return updated;
      } catch (error: any) {
        notify(
          "error",
          "Error al guardar",
          error.response?.data?.message ||
            "No se pudo actualizar el estado de mantenimiento"
        );
        throw error;
      } finally {
        setSaving(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return {
    status,
    loading,
    saving,
    loadError,
    fetchStatus,
    updateStatus,
  };
};
